import React, { useEffect, useState } from "react";
import { withBaseLayout } from "../layouts/Base";
import { Tab, Tabs, Grid, Box, Paper, AppBar, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import SupportPlanLogs from "./SupportPlanLogs";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TimeSinceLogin = () => {
  const storedLoginTime = localStorage.getItem("loginTime");
  const initialLoginTime = storedLoginTime
    ? new Date(JSON.parse(storedLoginTime))
    : new Date();

  const [loginTime, setLoginTime] = useState(initialLoginTime);
  const [elapsedTime, setElapsedTime] = useState("");

  useEffect(() => {
    // localStorage.setItem('loginTime', loginTime.toString());

    const intervalId = setInterval(() => {
      setElapsedTime(calculateTimeDifference(loginTime, new Date()));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [loginTime]);

  const calculateTimeDifference = (startTime, endTime) => {
    const diffInMilliseconds = endTime - startTime;
    const seconds = Math.floor(diffInMilliseconds / 1000);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours}h ${minutes}m ${remainingSeconds}s`;
  };

  return (
    <div>
      <p>You logged in: {elapsedTime} ago</p>
    </div>
  );
};

const UserProfileTab = () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const { reset, register } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (!!userData) {
      reset({ ...userData.user });
    }
  }, []);

  return (
    <Paper className="py-5">
      <form>
        <Grid container direction={"row"} spacing={2}>
          <Grid item xs={12}>
            <h5>User Profile Information</h5>
            <TimeSinceLogin />
          </Grid>
          <Grid item xs={12}>
            <Grid container direction={"row"} spacing={2}>
              <Grid item xs={6}>
                <TextField
                  {...register("nameFirst")}
                  margin="normal"
                  fullWidth
                  id="nameFirst"
                  label="First Name"
                  name="nameFirst"
                  autoComplete="nameFirst"
                  placeholder="Name First"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  {...register("nameLast")}
                  margin="normal"
                  fullWidth
                  id="nameLast"
                  label="Last Name"
                  name="nameLast"
                  autoComplete="nameLast"
                  placeholder="Last Name"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  {...register("loginName")}
                  margin="normal"
                  fullWidth
                  id="loginName"
                  label="Login Name"
                  name="loginName"
                  autoComplete="loginName"
                  placeholder="Login Name"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  {...register("userTypeName")}
                  margin="normal"
                  fullWidth
                  id="userTypeName"
                  label="User Type"
                  name="userTypeName"
                  autoComplete="userTypeName"
                  placeholder="User Type"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  {...register("timeZoneListCode")}
                  margin="normal"
                  fullWidth
                  id="timeZoneListCode"
                  label="Timezone"
                  name="timeZoneListCode"
                  autoComplete="timeZoneListCode"
                  placeholder="Timezone"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

const UserProfile = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Grid
      container
      direction={"column"}
      spacing={0}
      style={{ marginTop: "1rem" }}
    >
      <Grid item>
        <AppBar className="p-0" position="static">
          <Tabs
            value={activeTab}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab label="User Profile" {...a11yProps(0)} />
            <Tab label="Support Plan Logs" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
      </Grid>
      <Grid item>
        <TabPanel value={activeTab} index={0} component="div">
          <UserProfileTab />
        </TabPanel>
        <TabPanel value={activeTab} index={1} component="div">
          <Paper>
            <SupportPlanLogs logs={[]} />
          </Paper>
        </TabPanel>
      </Grid>
    </Grid>
  );
};
export default withBaseLayout(UserProfile);
